const Usuario = {
  searchUsuarioByCPFTotem: `${process.env.REACT_APP_BASE_URL_IP}/v1/clientes/noauth/buscar-cliente-cpf-totem`,
  loginCliente: `${process.env.REACT_APP_BASE_URL_IP}/v1/usuarios/auth/login-cliente`,
  tokenPublico: `${process.env.REACT_APP_BASE_URL_IP}/v1/usuarios/auth/token-publico`,
  smsClienteNegociacao: `${process.env.REACT_APP_BASE_URL_IP}/v1/clientes/noauth/sms-email-negociacao`,
  login: `${process.env.REACT_APP_BASE_URL_IP}/v1/usuarios/auth/login`,
  getLastCardData: `${process.env.REACT_APP_BASE_URL_IP}/v1/clientes/obter-dados-ultimo-cartao-emitido/PARAM_CPF?tipoCartao=PARAM_TIPO`,
  postValidarSenhaUsuario: `${process.env.REACT_APP_BASE_URL_IP}/v1/usuarios/noauth/validar-senha-usuario`,
};

const Autorizador = {
  searchMotivos: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/motivos-bloqueio/PARAM_ORIGIN`,
  bloquearCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/bloquear-cartao`,
  reemissaoCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/reemissao`,
  getTokenNumeroCartao: `${process.env.REACT_APP_BASE_URL_IP}/v2/autorizador/noauth/token-cartao`,
  getSaldoClienteByTokenCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/extrato/saldo`,
  getFaturaAtualCliente: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/extrato-fatura-atual`,
  validarCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/validar-cartao`,
  postExtratoCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/extrato-por-dias`,
  postExtractConsolidate: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/extrato-consolidado-por-dias/PARAM_DAYS`,
  putActivateCC: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/ativar-desbloquear`,
  putDesbloquearCC: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/desbloquear-cartao`,
  getClientCurrentyCategory: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/listar-categorias-cartao-atual/PARAM_CPF`,
  getClientCurrentyCategoryTokenCartao: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/listar-categorias-por-token-cartao/PARAM_TOKEN`,
  postListaExtratosPorDias: `${process.env.REACT_APP_BASE_URL_IP}/v1/autorizador/lista-extratos-por-dias/PARAM_DIAS/PARAM_LIMIT`
};

const Notificacao = {
  putValidaNotificacao: `${process.env.REACT_APP_BASE_URL_IP}/v1/push/validar`,
  putValidaNotificacaoProposta: `${process.env.REACT_APP_BASE_URL_IP}/v1/push/validar-celular`,
  potEnviaPushSMSWhastsApp: `${process.env.REACT_APP_BASE_URL_IP}/v1/notificacoes/whatsapp/enviar-whatsapp-codigo-desbloqueio`,
  potEnviaPushSMS: `${process.env.REACT_APP_BASE_URL_IP}/v1/notificacoes/sms/enviar-sms-notificacao`,
  potEnviaPushSMSProposta: `${process.env.REACT_APP_BASE_URL_IP}/v1/notificacoes/sms/enviar-sms-notificacao-celular`,
};

const Proposta = {
  getValidateProposal: `${process.env.REACT_APP_BASE_URL_IP}/v1/ficha-proposta/noauth/validar-proposta/PARAM_CPF`,
  postInitialProposal: `${process.env.REACT_APP_BASE_URL_IP}/v1/ficha-proposta/noauth/proposta-inicial`,
};

const Cobranca = {
  getCharge: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/obter-parcelamento-fatura-por-cpf/PARAM_CPF`,
  getQRCode: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/pix-gerar-qrcode-fatura?idFatura=PARAM_ID_FATURA`,
  getStatusPixPayment: `${process.env.REACT_APP_BASE_URL_IP}/v1/websockets/cobrancas/status-pix/PARAM_ID_TX`,
  getPaymentVoucherPix: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/download-comprovante-pix?txId=PARAM_ID_TX`,
  postSendPaymentVoucherEmail: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/enviar-email-comprovante-pix?txId=PARAM_ID_TX`,
  postSendPaymentVocuherAntecipationEmail: `${process.env.REACT_APP_BASE_URL_IP}/v1/email/noauth/enviar-email-comprovante-pix-totem`,
  getInvoicePaymentVoucher: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/buscar-por-idfatura?idFatura=PARAM_ID_FATURA`,
  getAntecipationPurchaseSearch: `${process.env.REACT_APP_BASE_URL_IP}/v1/antecipacoes/buscar-compras?cpf=PARAM_CPF`,
  generatePixAntecipation: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/pix/gerar`,
  postCreateAntecipationPurchase: `${process.env.REACT_APP_BASE_URL_IP}/v1/antecipacoes/criar-antecipacoes`,
  getAntecipationHistory: `${process.env.REACT_APP_BASE_URL_IP}/v1/antecipacoes/historico-tipo-antecipacao?cpf=PARAM_CPF&tipo=PARAM_TIPO`,
  putFinishAntecipationPurchase: `${process.env.REACT_APP_BASE_URL_IP}/v1/antecipacoes/quitar-txid/PARAM_TXID`,
  getPaymentAntecipation: `${process.env.REACT_APP_BASE_URL_IP}/v1/cobrancas/pix/cobranca/PARAM_TXID`,
};

const Relatorio = {
  getListaFaturas: `${process.env.REACT_APP_BASE_URL_IP}/v1/relatorios/obter-lista-faturas?cpf=PARAM_CPF&numeroCartao=PARAM_NRCARTAO&tokenCartao=PARAM_TOKEN&tipoFatura=PARAM_TIPO`,
  getInvoicePrint: `${process.env.REACT_APP_BASE_URL_IP}/v1/relatorios/fatura-totem-impressao?numeroCartao=PARAM_NRCARTAO`
};

const Pagamentos = {
  postCalculaParcelaFatura: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/calcular-parcelamento-fatura`,
  postMakePaymentInvoice: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/iniciar-pagamento-fatura`,
  postSavePaymentInvoice: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/finalizar-pagamento-fatura`,
  postLogErrorPaymentInvoice: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/logger-erro-pagamento-fatura`,
  postMakePaymentInvoicePix: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/iniciar-pagamento-fatura-pix`,
  getPaymentHour: `${process.env.REACT_APP_BASE_URL_IP}/v1/pagamentos/data-pagamento/PARAM_ID_PAGAMENTO`,
};

const PagamentosAdaga = {
  getStatusPinPadAdaga: "http://localhost:3000/status",
  postMakePaymentInvoiceAdaga: "http://localhost:3000/start-transaction",
};

const Endpoints = {
  usuario: Usuario,
  autorizador: Autorizador,
  notificacao: Notificacao,
  proposta: Proposta,
  relatorio: Relatorio,
  cobranca: Cobranca,
  pagamentos: Pagamentos,
  pagamentosAdaga: PagamentosAdaga,
};

export default Endpoints;
